import { api } from 'app/api';
import { DEFAULT_LIMIT } from 'modules/threads/constants';
import { IUser } from 'types/user';
import { IId, IPaginatedResponse } from '../../types';
import { IAllEventRequestParams, IEvent, IEventRequestParams, IEventResponse } from './types';

export const eventsApi = api.injectEndpoints({
  endpoints: (build) => ({
    createEvent: build.mutation<IEventResponse, IEvent>({
      query: (payload) => ({
        url: '/events/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['events'],
    }),
    getAllEvents: build.query<IPaginatedResponse<IEventResponse>, IAllEventRequestParams>({
      query: ({ userId, status = '', limit = DEFAULT_LIMIT, dateRange }) => ({
        url: `/events/`,
        params: {
          due_date__range: dateRange ? `${dateRange[0]},${dateRange[1]}` : '',
          assignees: userId ?? '',
          status,
          limit,
        },
      }),
      providesTags: ['events'],
    }),
    getEvents: build.query<IPaginatedResponse<IEventResponse>, IEventRequestParams>({
      query: ({ id, eventId, limit = DEFAULT_LIMIT }) => ({
        url: `/threads/${id}/events/?event_id=${eventId}&limit=${limit}`,
      }),
      providesTags: (_, __, args) => [{ type: 'events', thread: args.id }],
    }),
    getEvent: build.query<IEventResponse, IId>({
      query: ({ id }) => ({
        url: `/events/${id}/`,
      }),
      keepUnusedDataFor: 2,
      providesTags: ['events'],
    }),
    deleteEvent: build.mutation<unknown, number>({
      query: (id) => ({
        url: `/events/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['events'],
    }),
    editEvent: build.mutation<IEventResponse, IEvent>({
      query: ({ id, ...payload }) => ({
        url: `/events/${id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['events'],
    }),
    getEventAssignees: build.query<IPaginatedResponse<IUser>, IId>({
      query: ({ id }) => ({
        url: `threads/${id}/allowed-event-assignees/?limit=${DEFAULT_LIMIT}`,
      }),
    }),
  }),
});

export const {
  useCreateEventMutation,
  useGetAllEventsQuery,
  useGetEventsQuery,
  useDeleteEventMutation,
  useEditEventMutation,
  useGetEventAssigneesQuery,
  useGetEventQuery,
} = eventsApi;
